import { call, put } from "redux-saga/effects";
import { Types } from "../reducers/profileReducer";

import { apiauth } from "services/api";

export function* profileChangePageSaga(action) {
  let response;
  let data;

  try {
    response = yield call(() => {
      return apiauth().get(
        `profiles?page=${action.page + 1}&perPage=${action.perPage}`,
        {
          params: action.search,
        }
      );
    });

    data = response.data;

    yield put({ type: Types.PROFILE_CHANGE_PAGE_SUCCESS, data });
  } catch (error) {
    if (error.response.status === 404 || error.response.status === 500) {
      data = { message: "Falha na tentativa de listar os perfis" };
    } else {
      data = error.response.data;
    }

    yield put({ type: Types.PROFILE_CHANGE_PAGE_FAILURE, data });
  }
}
